import React from "react";
import { Modal as AntModal } from "antd";
import styled from "styled-components";
import {
  BonusModalEN,
  BonusModalCH,
  BonusModalMM,
  FirstTopUpAccept,
  FirstTopUpReject,
  PromoBonusModalCH,
  PromoBonusModalMM,
  PromoBonusModalEN,
} from "@assets";
import Lottie from "react-lottie";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import { localStorage } from "@utils";
import { ENGLISH_LANGUAGE_CODE_LK, BURMESE_LANGUAGE_CODE_LK } from "@constants";

const Modal = styled(AntModal)`
  padding: 0px !important;
  .ant-modal-title {
    text-align: center;
    color: ${(props) => props.theme.primaryColor};
  }
  .ant-modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .ant-modal-footer {
    text-align: center;
  }
`;

const Container = styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  margin: 18px 0;
  height: 322px;
  width: 100%;

  @media screen and (max-width: 450px) {
    top: 40px;
  }
  @media screen and (max-width: 350px) {
    top: 30px;
  }
`;

const LabelContainer = styled.div`
  padding-top: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media screen and (max-width: 450px) {
    padding-top: 120px;
  }
  @media screen and (max-width: 350px) {
    padding-top: 110px;
  }
`;

const FirstLabel = styled.div`
  font-weight: 400;
  color: #fff;
  width: 60%;
  font-size:${props => props.isBurmese === "true" ? "10px" : '11px'};
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 450px) {
    font-size:${props => props.isBurmese === "true" ? "8px" : '9px'};
  }
  @media screen and (max-width: 350px) {
    font-size:${props => props.isBurmese === "true" ? "7px" : '8px'};
  }
`;

const TopUpLabel = styled.div`
  font-weight: 400;
  color: #fff;
  width: 60%;
  font-size:${props => props.isBurmese === "true" ? "10px" : '11px'};
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 450px) {
    font-size:${props => props.isBurmese === "true" ? "8px" : '9px'};
  }
  @media screen and (max-width: 350px) {
    font-size:${props => props.isBurmese === "true" ? "7px" : '8px'};
  }
`;

const TotalLabel = styled.div`
 font-weight: 400;
  color: #fff;
  width: 60%;
  font-size:${props => props.isBurmese === "true" ? "10px" : '11px'};
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 450px) {
    font-size:${props => props.isBurmese === "true" ? "8px" : '9px'};
  }
  @media screen and (max-width: 350px) {
    font-size:${props => props.isBurmese === "true" ? "7px" : '8px'};
  }
`;

const RuleLabel = styled.div`
  padding-bottom: 8px;
  font-size: 10px;
  color: #FFC200;

  @media screen and (max-width: 370px) {
    font-size: 9px;
    padding-bottom: 4px;
  }
`;

const BtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const CancelButton = styled.button`
  padding-top: 4px;
  background-image: url(${FirstTopUpReject});
  background-size: cover;
  background-repeat: no-repeat;
  width: 100px;
  height: 40px;
  color: #56008E;
  font-size: 13px;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 50px;

  @media screen and (max-width: 450px) {
    font-size: 10px;
    width: 80px;
  }
  @media screen and (max-width: 350px) {
    font-size: 9px;
    width: 70px;
  }
`;

const AcceptButton = styled.button`
  padding-top: 4px;
  background-image: url(${FirstTopUpAccept});
  background-size: cover;
  background-repeat: no-repeat;
  width: 100px;
  height: 40px;
  color: #FFF200;
  font-size: 13px;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 50px;
  position: relative;

  @media screen and (max-width: 450px) {
    font-size: 10px;
    width: 80px;
  }
  @media screen and (max-width: 350px) {
    font-size: 9px;
    width: 70px;
  }
`;

const LottieWrapper = styled.div`
  width: 450px;
  position: relative;

  @media screen and (max-width: 450px) {
    width: 350px;
  }
  @media screen and (max-width: 350px) {
    width: 300px;
  }
`;

const Bottom = styled.div`
  position: absolute;
  bottom: 16px;
  width: 100%;
  text-align: center;
  @media screen and (max-width: 450px) {
    bottom: 80px;
  }
  @media screen and (max-width: 350px) {
    bottom: 100px;
  }
`;

const FirstBonusConfirmModal = ({
  exceed_bonus_limit,
  total_amount,
  max_topup_reward,
  amount,
  bonus_percent,
  open,
  onBonusAccept,
  handleClose,
  isPromoUser,
}) => {
  const { t } = useTranslation();
  const userPreferedLanguage = localStorage.getUserPreferedLanguage();

  const calculateBonus = () => {
    return exceed_bonus_limit ? max_topup_reward : Math.ceil(amount * bonus_percent * 0.01);
  };

  const calculateTotal = () => {
    return exceed_bonus_limit ? total_amount : (amount + calculateBonus());
  };

  const getBonusModal = () => {

    if (userPreferedLanguage === ENGLISH_LANGUAGE_CODE_LK) {
      return isPromoUser ? PromoBonusModalEN : BonusModalEN;
    } else if (userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK) {
      return isPromoUser ? PromoBonusModalMM : BonusModalMM;
    } else {
      return isPromoUser ? PromoBonusModalCH : BonusModalCH;
    }
  };

  return (
    <>
      <Modal centered destroyOnClose closable={false} open={open} footer={null}>
        <LottieWrapper>
          <Lottie
            options={{
              animationData: getBonusModal(),
            }}
          />
          <Container>
            <LabelContainer>
              <FirstLabel
                isBurmese={userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK ? "true" : 'false'}
              >
                {t("wallet.firstTopUpBonusPercentage1")}
                {" - "}
                {<span>{bonus_percent}%</span>}
              </FirstLabel>
              <TopUpLabel
                isBurmese={userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK ? "true" : 'false'}
              >
                {t("wallet.firstTopUpBonusTopUpAndBonus1")}
                {" - "}
                <span>{getFormattedNumber(amount)}</span>
                {", "}
                {t("wallet.firstTopUpBonusTopUpAndBonus2")}
                {" - "}
                <span>{getFormattedNumber(calculateBonus())}</span>
              </TopUpLabel>
              <TotalLabel
                isBurmese={userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK ? "true" : 'false'}
              >
                {t("wallet.firstTopUpBonusTotal1")}
                {" "}
                <span>{getFormattedNumber(calculateTotal())}</span>
                {" "}
                {t("wallet.firstTopUpBonusTotal2")}
              </TotalLabel>
              {exceed_bonus_limit &&
                <TotalLabel
                  isBurmese={userPreferedLanguage === BURMESE_LANGUAGE_CODE_LK ? "true" : 'false'}
                >
                  {t("wallet.maxBonusAmount", { max_topup_reward: getFormattedNumber(max_topup_reward) })}
                </TotalLabel>
              }
            </LabelContainer>
            <Bottom>
              <RuleLabel>{t("wallet.firstTopUpBonusRule")}</RuleLabel>
              <BtnWrapper>
                <CancelButton onClick={handleClose}>
                  {t("wallet.reject")}
                </CancelButton>
                <AcceptButton onClick={onBonusAccept}>
                  {t("wallet.accept")}
                </AcceptButton>
              </BtnWrapper>
            </Bottom>
          </Container>
        </LottieWrapper>
      </Modal>
    </>
  );
};

export default FirstBonusConfirmModal;